import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ModalRef } from '@freelancer/ui';
import { ButtonColor, ButtonSize } from '@freelancer/ui/button';
import { Margin } from '@freelancer/ui/margin';
import { FontWeight, TextAlign, TextSize } from '@freelancer/ui/text';

@Component({
  selector: 'app-payment-share-kyc-modal',
  template: `
    <fl-bit flTrackingSection="PaymentShareKycModal">
      <fl-picture
        i18n-alt="Image for Proof of Identity"
        class="CentralImage"
        alt="Proof of Identity Image"
        [src]="'/kyc/proof-of-identity.svg'"
      ></fl-picture>
      <fl-text
        i18n="Kyc Verification heading"
        [size]="TextSize.MID"
        [weight]="FontWeight.BOLD"
        [textAlign]="TextAlign.CENTER"
        [flMarginBottom]="Margin.SMALL"
      >
        Verification required
      </fl-text>
      <fl-text
        i18n="kyc redirect modal text"
        [textAlign]="TextAlign.CENTER"
        [flMarginBottom]="Margin.MID"
      >
        You need to complete your identity verification before setting up
        payment sharing. Please click the continue button below to complete this
        process.
      </fl-text>
      <fl-bit class="Buttons">
        <fl-button
          i18n="CancelButton"
          [size]="ButtonSize.SMALL"
          [color]="ButtonColor.DEFAULT"
          [flMarginRight]="Margin.MID"
          [flTrackingLabel]="'CancelButton'"
          (click)="handleCancelClick()"
        >
          Cancel
        </fl-button>
        <fl-button
          i18n="ContinueButton"
          [size]="ButtonSize.SMALL"
          [color]="ButtonColor.SECONDARY"
          [flTrackingLabel]="'CancelButton'"
          [link]="'/users/kyc/verification-center-home'"
        >
          Continue
        </fl-button>
      </fl-bit>
    </fl-bit>
  `,
  styleUrls: ['./payment-share-kyc-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentShareKycModalComponent {
  Margin = Margin;
  TextSize = TextSize;
  TextAlign = TextAlign;
  FontWeight = FontWeight;
  ButtonColor = ButtonColor;
  ButtonSize = ButtonSize;

  constructor(private modalRef: ModalRef<PaymentShareKycModalComponent>) {}

  handleCancelClick() {
    this.modalRef.close();
  }
}
